import { BaseModel } from './base.model';

export class UserTypeModel extends BaseModel {

    name: string;
    menu_ids: number[];
    access_rule: number;
    is_operator: boolean;

    static validate(userType: UserTypeModel): boolean {
        return !!(userType.name) && !!(userType.access_rule);
    }

    constructor(user_type?: UserTypeModel) {
        super();

        this.name = user_type ? user_type.name || null : null;
        this.menu_ids = user_type ? user_type.menu_ids || [] : [];
        this.access_rule = user_type ? user_type.access_rule || null : null;
        this.is_operator = user_type ? user_type.is_operator || false : false;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/user-type.model.ts